export default {
  // 性别
  articleStatus: [
    { value: 0, text: '审核未通过' },
    { value: 1, text: '审核通过' },
    { value: 2, text: '已定时' },
    { value: 3, text: '已退回' },
    { value: 4, text: '草稿' },
    { value: 5, text: '已下架' }
  ],
  auditStatus: [
    { value: 0, text: '审核中' },
    { value: 1, text: '审核通过' },
    { value: 2, text: '审核不通过' },
    { value: 3, text: '申请取消' }
  ],
  inviteStatus: [
    { value: 0, text: '邀请处理中' },
    { value: 1, text: '通过邀请' },
    { value: 2, text: '拒绝邀请' }
  ],
  inviteType: [
    { value: 'link', text: '组织链接邀请' },
    { value: 'qrcode', text: '组织二维码邀请' },
    { value: 'sms', text: '短信邀请' }
  ],
  stockholderType: [
    { value: 1, text: '自然人' },
    { value: 2, text: '法人' }
  ],
  quotedStatus: [
    { value: 0, text: '未挂牌' },
    { value: 1, text: '挂牌' },
    { value: '', text: '/' }
  ]
}



// WEBPACK FOOTER //
// ./src/filter/dictionary.js